import { dsVar, FONT_BODY, FONT_MONO } from './tokens';

/**
 * The one type spec for data tables, so a table on a page and a table in a
 * drawer read as the same thing: column headers are small uppercase JetBrains
 * Mono labels, cells are Inter body text. Backgrounds, borders and padding stay
 * with each table, which sits in different containers.
 */
export const tableHeadTypeSx = {
    fontFamily: FONT_MONO,
    fontSize: '0.6875rem',
    fontWeight: 600,
    letterSpacing: '0.05em',
    lineHeight: 1.4,
    textTransform: 'uppercase' as const,
    color: dsVar('fg-2'),
};

export const tableCellTypeSx = {
    fontFamily: FONT_BODY,
    fontSize: '0.8125rem',
    fontWeight: 400,
    lineHeight: 1.45,
    // MUI's body2 adds 0.01em of tracking, which made MUI tables set looser than hand-built ones.
    letterSpacing: 'normal',
    color: dsVar('fg-soft'),
};

export const tableCellPadSx = { px: 1.5, py: 1.25 };
